import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatDateWithoutTime = (date) => new Date(format(new Date(date), 'yyyy-MM-dd'));

export const readableDateWithTime = (date) => {
  if (!date) {
    return null;
  }

  return format(new Date(date), 'dd.MM.yyyy (HH:mm)', { locale: ru });
};
